module.exports = __webpack_public_path__ + "img/Email-campaign-Recovered.a8f0713d.png";